import RequestState from 'Enums/RequestState'
import IFFIlterType from 'Enums/IFFilterType'
/**
 * The initial values for the redux state.
 */
export const INITIAL_STATE = {
  fetchChargingTokensRequestState: RequestState.UNINITIALIZED,
  editChargingTokenRequestState: RequestState.UNINITIALIZED,
  deleteChargingTokenRequestState: RequestState.UNINITIALIZED,
  createChargingTokenRequestState: RequestState.UNINITIALIZED,
  createChargingTokenBulkRequestState: RequestState.UNINITIALIZED,
  downloadChargingTokenSampleFileRequestState: RequestState.UNINITIALIZED,
  getChargingTokensCountRequestState: RequestState.UNINITIALIZED,
  filterText: '',
  chargingTokens: [],
  paginationOffset: 0,
  count: 0,
  chargingTokenFilter: [
    {
      type: IFFIlterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
    {
      type: IFFIlterType.CHECK,
      title: 'Status',
      data: ['Active', 'Inactive', 'Deactivated'],
      initialValue: [],
      value: [],
    },
    {
      type: IFFIlterType.CHECK,
      title: 'Type',
      data: ['Rfid', 'Virtual'],
      initialValue: [],
      value: [],
    },
    {
      type: IFFIlterType.DATE_RANGE,
      title: 'Date',
      initialValue: [],
      value: [],
    },
  ],
}
